import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd6ba4e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "mb-0 text-end"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-0 text-end"
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-0 text-end"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-0 text-end"
}
const _hoisted_8 = {
  key: 0,
  class: "truncate block"
}

import { computed } from "vue";
import { normalizeTableRow } from "./composables/normalizeTableRow";
import {
  isFooterRow,
  usePhieuXuatKhoTableCellApi,
  type PhieuXuatKhoThuHoiSubColumnId,
} from "./composables/usePhieuXuatKhoTableCellApi";
import type { PhieuXuatKhoTableRow } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuThuHoiCell',
  props: {
    row: {},
    subColumnId: {}
  },
  setup(__props: any) {

const props = __props;

const api = usePhieuXuatKhoTableCellApi();
const isSummaryMode = api.isSummaryMode;
const normalized = computed(() => normalizeTableRow(props.row));

const isThuHoiRow = computed(() => {
  if (normalized.value.idVatTu != null) {
    return api.isVatTuThuHoi(normalized.value.idVatTu);
  }

  return !!normalized.value.thuHoi;
});

const canEditThuHoi = computed(() =>
  normalized.value.idVatTu != null
    ? api.canEditThuHoiFields(normalized.value.idVatTu)
    : false
);

const summaryValue = (subColumnId: PhieuXuatKhoThuHoiSubColumnId) => {
  switch (subColumnId) {
    case "tai_sd":
      return normalized.value.slTaiSd != null
        ? api.formatQuantity(normalized.value.slTaiSd)
        : "-";
    case "mat":
      return normalized.value.slMat != null
        ? api.formatQuantity(normalized.value.slMat)
        : "-";
    case "so_luong_phe_lieu":
      return normalized.value.slPheLieu != null
        ? api.formatQuantity(normalized.value.slPheLieu)
        : "-";
    case "quy_doi_kg":
      return normalized.value.kgPheLieu != null
        ? api.formatQuantity(normalized.value.kgPheLieu)
        : "-";
    case "ma_vt_thu_hoi":
      return normalized.value.maVtThuHoi ?? "-";
    default:
      return "-";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_unref(isFooterRow)(_ctx.row))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
    : (_unref(isSummaryMode))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(isThuHoiRow.value ? summaryValue(_ctx.subColumnId) : "-"), 1)
        ], 64))
      : (_ctx.subColumnId === 'tai_sd')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(isThuHoiRow.value
          ? _unref(api).formatQuantity(
              _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.tai_sd ?? 0
            )
          : "-"), 1))
        : (_ctx.subColumnId === 'mat')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (canEditThuHoi.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.mat,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.mat) = $event)),
                      controls: false,
                      min: 0,
                      style: {"width":"100%"},
                      type: "number",
                      onBlur: _cache[1] || (_cache[1] = () => _unref(api).onMatBlur(normalized.value.idVatTu!)),
                      onChange: _cache[2] || (_cache[2] = (value) => _unref(api).onMatChange(normalized.value.idVatTu!, value)),
                      onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select())),
                      onWheel: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 8, ["modelValue"])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(isThuHoiRow.value
          ? _unref(api).formatQuantity(
              _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.mat ?? 0
            )
          : "-"), 1))
            ], 64))
          : (_ctx.subColumnId === 'so_luong_phe_lieu')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (canEditThuHoi.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_phe_lieu,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_phe_lieu) = $event)),
                        controls: false,
                        min: 0,
                        style: {"width":"100%"},
                        type: "number",
                        onBlur: _cache[6] || (_cache[6] = () => _unref(api).onPheLieuBlur(normalized.value.idVatTu!)),
                        onChange: _cache[7] || (_cache[7] = (value) => _unref(api).onPheLieuChange(normalized.value.idVatTu!, value)),
                        onFocus: _cache[8] || (_cache[8] = ($event: any) => ($event.target.select())),
                        onWheel: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(isThuHoiRow.value
          ? _unref(api).formatQuantity(
              _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)
                ?.so_luong_phe_lieu ?? 0
            )
          : "-"), 1))
              ], 64))
            : (_ctx.subColumnId === 'quy_doi_kg')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (canEditThuHoi.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_el_input_number, {
                          modelValue: _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.quy_doi_kg,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.quy_doi_kg) = $event)),
                          class: _normalizeClass({
          'is-error':
            _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_phe_lieu > 0 &&
            _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.quy_doi_kg === 0,
        }),
                          controls: false,
                          disabled: 
          _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_phe_lieu === 0
        ,
                          min: 0,
                          style: {"width":"100%"},
                          type: "number",
                          onBlur: _cache[11] || (_cache[11] = () => _unref(api).onQuyDoiBlur(normalized.value.idVatTu!)),
                          onChange: _cache[12] || (_cache[12] = (value) => _unref(api).onQuyDoiChange(normalized.value.idVatTu!, value)),
                          onFocus: _cache[13] || (_cache[13] = ($event: any) => ($event.target.select())),
                          onWheel: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"]))
                        }, null, 8, ["modelValue", "class", "disabled"])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(isThuHoiRow.value
          ? _unref(api).formatQuantity(
              _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.quy_doi_kg ?? 0
            )
          : "-"), 1))
                ], 64))
              : (_ctx.subColumnId === 'ma_vt_thu_hoi')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (!_unref(isSummaryMode))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(isThuHoiRow.value
          ? _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.ma_vt_thu_hoi ||
            "-"
          : "-"), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(isThuHoiRow.value ? normalized.value.maVtThuHoi ?? "-" : "-"), 1)
                        ], 64))
                  ], 64))
                : _createCommentVNode("", true)
}
}

})